import React from "react";
import { alpha, styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";

const CssTextField = styled(TextField)({
  input: {
    color: "white",
  },
  "& label.Mui-focused": {
    color: "white",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "white",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "white",
    },
    "&:hover fieldset": {
      borderColor: "white",
    },
    "&.Mui-focused fieldset": {
      borderColor: "white",
    },
  },
});
export default function TextInputField(props) {
  const {
    label,
    password = false,
    width,
    height,

    errorMessage = "",
    onChange,
  } = props;

  const id = "input-id" + label.substring(" ")[0];

  return (
    <div>
      {label && (
        <InputLabel
          sx={{
            color: "white",
          }}
          htmlFor={id}
        >
          {label}
        </InputLabel>
      )}
      <CssTextField
        id={id}
        style={{ width: width, height: height, color: "white" }}
        borderColor="white"
        variant="outlined"
        type={password ? "password" : "text"}
        error={errorMessage !== ""}
        helperText={errorMessage}
        onChange={onChange}
        color="info"
      />
    </div>
  );
}
